import React from 'react'

export function SalesAgentDetails() {
    return (

        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6 border-end">
                                            {/* <h5 className="secHeading">Sender Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    ADD SALES AGENTS: Agent Name, Contact No., Email, Registered Address, Taxation Details, Total Discount

                                                    <tr>
                                                        <td className="py-1"> Agent Name - </td>
                                                        <td className="py-1"> loram</td>
                                                    </tr>


                                                    <tr>
                                                        <td className="py-1">Contact No. - </td>
                                                        <td className="py-1">2354623466</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Email/mob- </td>
                                                        <td className="py-1">demo@gmail.com</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Taxation details - </td>
                                                        <td className="py-1">xyz</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-lg-6 col-md-6 border-end">
                                            {/* <h5 className="secHeading">Receiver Details</h5> */}
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1"> Registered Address- </td>
                                                        <td className="py-1">Xyz</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Total Discount - </td>
                                                        <td className="py-1">20%</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">  Customer Discount - </td>
                                                        <td className="py-1">10%</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1"> Incentive - </td>
                                                        <td className="py-1">5%</td>
                                                    </tr>


                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr />

                </div>
            </div>
        </div>

    )
}
